<template>
    <div class="fill-height grey lighten-4">

        <v-row class="fill-height" justify="center">
            <v-col cols="12" md="6" lg="3" align-self="center">

                <!-- login view -->
                <v-card class="elevation-10" v-show="view == 'login'">
                    <v-card-title>Login</v-card-title>
                    <v-card-subtitle>Enter your credential to enter the system</v-card-subtitle>
                    <v-card-text>
                        <v-alert v-model="alert" dense text :color="alertColor" border="left">{{ alertMessage }}</v-alert>
                        <v-text-field label="Email" outlined v-model="email" :error-messages="emailError" @keypress.enter="loginRequest"></v-text-field>
                        <v-text-field label="Password" type="password" outlined v-model="password" :error-messages="passwordError" @keypress.enter="loginRequest"></v-text-field>
                        <v-btn depressed block color="primary" @click="loginRequest" :loading="processing">Log in</v-btn>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="grey lighten-5">
                        <v-btn text depressed small color="primary" @click="view = 'forgot'">Forgot Password?</v-btn>
                    </v-card-actions>
                </v-card>

                <!-- forgot password view -->
                <v-card class="elevation-10" v-show="view == 'forgot'">
                    <v-card-title>Recover password</v-card-title>
                    <v-card-subtitle>Enter your account email below to recover your password</v-card-subtitle>
                    <v-card-text>
                        <v-alert v-model="recoverAlert" dense text :color="recoverAlertColor" border="left">{{ recoverAlertMessage }}</v-alert>
                        <v-text-field label="Email" outlined v-model="forgotPasswordEmail" :error-messages="forgotPasswordEmailError" @keypress.enter="recover"></v-text-field>
                        <v-btn depressed block color="primary" @click="recover" :loading="processing">Recover</v-btn>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="grey lighten-5">
                        <v-btn text depressed small color="primary" @click="view = 'login'">Go Back</v-btn>
                    </v-card-actions>
                </v-card>

                <!-- reset password view -->
                <v-card class="elevation-10" v-show="view == 'reset'">
                    <v-card-title>Recover password</v-card-title>
                    <v-card-subtitle>Enter your account email below to recover your password</v-card-subtitle>
                    <v-card-text>
                        <v-alert v-model="alert" dense text :color="alertColor" border="left">{{ alertMessage }}</v-alert>
                        <v-text-field label="Password" type="password" outlined v-model="recoverPassword" :error-messages="recoverPasswordError" @keypress.enter="reset"></v-text-field>
                        <v-text-field label="Confirm Password" type="password" outlined v-model="recoverPasswordConfirmation" :error-messages="recoverPasswordConfirmationError" @keypress.enter="reset"></v-text-field>
                        <v-btn depressed block color="primary" @click="reset" :loading="processing">Reset Password</v-btn>
                    </v-card-text>
                </v-card>

            </v-col>
        </v-row>

    </div>
</template>

<script>
export default {
    data() {
        return {
            view: 'login',

            email: '',
            emailError: '',
            password: '',
            passwordError: '',

            forgotPasswordEmail: '',
            forgotPasswordEmailError: '',

            recoverPassword: '',
            recoverPasswordError: '',
            recoverPasswordConfirmation: '',
            recoverPasswordConfirmationError: '',

            alert: false,
            alertColor: 'red',
            alertMessage: '',

            recoverAlert: false,
            recoverAlertColor: 'green',
            recoverAlertMessage: '',

            processing: false,
        }
    },
    methods: {
        isLoginValid() {
            let errorFound = false;
            this.emailError = this.passwordError = '';
            this.alert = false;

            if( this.email.length < 5 ) {
                this.emailError = 'valid email required';
                errorFound = true;
            }
            if( this.password.length < 4 ) {
                this.passwordError = 'must be valid';
                errorFound = true;
            }

            return !errorFound;
        },
        loginRequest() {
            if( !this.isLoginValid() )
                return;

            let axiosOptions = {
                url: '/proc/data.php',
                method: 'post',
                data: {
                    email: this.email,
                    password: this.password
                },
                params: {
                    action: 'login'
                },
                json: true,
            };

            this.processing = true;
            this.$http( axiosOptions )
                .then( response => {
                    this.processing = false;
                    if( response.data.status == true && ( response.data.action == undefined || response.data.action == null ) ) {
                        this.login( response.data.token );
                        this.$router.push('/');
                    }
                    else if( response.data.status == true && response.data.action != undefined && response.data.action != null ) {
                        this.password = '';
                        if( response.data.action == 'reset')
                            this.view = 'reset';
                    }
                    else if( !response.data.status ) {
                        this.password = '';
                        this.alertMessage = response.data.message;
                        this.alertColor = 'red';
                        this.alert = true;
                    }
                });
        },
        isResetValid() {
            let errorFound = false;
            this.recoverPasswordError = this.recoverPasswordConfirmationError = '';
            this.alert = false;

            if( this.recoverPassword.length < 4 ) {
                this.recoverPasswordError = 'must be valid';
                errorFound = true;
            }
            if( this.recoverPasswordConfirmation.length < 4 ) {
                this.recoverPasswordConfirmationError = 'must be valid';
                errorFound = true;
            }

            return !errorFound;
        },
        reset() {
            if( !this.isResetValid() )
                return;

            let axiosOptions = {
                url: '/proc/data.php',
                method: 'post',
                data: {
                    email: this.email,
                    password: this.recoverPassword,
                    confirmation: this.recoverPasswordConfirmation
                },
                params: {
                    action: 'resetPassword'
                },
                json: true,
            };

            this.processing = true;
            this.$http( axiosOptions )
                .then( response => {
                    this.processing = false;
                    if( response.data.status == true ) {
                        this.$router.push('/');
                    }
                    else {
                        this.recoverPasswordConfirmation = '';
                        this.alertMessage = response.data.message;
                        this.alertColor = 'red';
                        this.alert = true;
                    }
                });
        },
        isRecoverValid() {
            let errorFound = false;
            this.forgotPasswordEmailError = '';
            this.recoverAlert = false;

            if( this.forgotPasswordEmail.length < 5 ) {
                this.forgotPasswordEmailError = 'must be valid';
                errorFound = true;
            }

            return !errorFound;
        },
        recover() {
            if( !this.isRecoverValid() )
                return;

            let axiosOptions = {
                url: '/proc/data.php',
                method: 'post',
                data: {
                    email: this.forgotPasswordEmail,
                },
                params: {
                    action: 'recoverPassword'
                },
                json: true,
            };

            this.processing = true;
            this.$http( axiosOptions )
                .then( response => {
                    this.processing = false;
                    if( response.data.status == true ) {
                        this.forgotPasswordEmail = '';
                        this.recoverAlertMessage = response.data.message;
                        this.recoverAlertColor = 'green';
                        this.recoverAlert = true;
                    }
                    else {
                        this.recoverAlertMessage = response.data.message;
                        this.recoverAlertColor = 'red';
                        this.recoverAlert = true;
                    }
                });
        }
    }
}
</script>

<style scoped>

</style>